import { render, staticRenderFns } from "./faqSection.vue?vue&type=template&id=9edb7d66&scoped=true&v-if=lang%20%26%26%20__(title)&"
import script from "./faqSection.vue?vue&type=script&lang=js&"
export * from "./faqSection.vue?vue&type=script&lang=js&"
import style0 from "./faqSection.scss?vue&type=style&index=0&id=9edb7d66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9edb7d66",
  null
  
)

export default component.exports